export default __webpack_public_path__ + "static/media/top-arrow.b49ea093.svg";